<!--
Login screen
@author bmk11u
-->
<template>
  <div>
    <div id="loginLogo">
      <img class="loginLogoImg" src="@/assets/UofG_App_Logo.svg" alt="University of Glasgow Logo" height="110"/>
    </div>
    <Spinner ref="spinner" />
    <main :key="disableLogin" class="p-2" style="margin-left:24px;margin-right:24px;text-align:center;">
      <div v-if="errorMsg !== ''" class="error-message">
        {{ errorMsg }}
      </div>
      <!-- <div class="form-group form-check">
        <input type="checkbox" class="form-check-input" v-model="rememberMe" id="rememberMe">
        <label class="form-check-label" for="rememberMe">Remember me on this device</label>
      </div> -->
      <button :class="disableLogin ? 'loginButtonDisabled' : 'loginButton'" :disabled="disableLogin" @click="checkLogin">Log in</button>
      <a class="privacyStatement" href="http://www.gla.ac.uk/legal/privacy/" target="_new">Privacy and cookies</a>
      <AppStoreLink />
    </main>
  </div>
</template>

<script>
// import Logo from '@/components/Logo.vue'
import axios from 'axios'
import { msalMethods } from '@/composables/MSALCommon.js'
const { getAccount, getToken, startRedirect, catchRedirect } = msalMethods()

// import $cookies from 'vue-cookies'
import AppStoreLink from '@/components/AppStoreLink.vue'
import { findRoomId } from '@/mixins/CustomUrls.js'
import * as lst from '@/components/localStorage.js'


export default {
  name: 'login',
  components: {
    AppStoreLink
  },
  // mixins: [CustomUrls],
  data () {
    return {
      accessToken: '',
      disableLogin: false,
      rememberMe: true,
      errorMsg: '',
      buttonClicked: false // stop enabledLogin check from firing when we click submit
    }
  },
  async mounted () {
    // if we're being launched in a mobile browser
    // offer to launch ourselves in the mobile app
    // (4.3 and up)
    if (this.isInMobileBrowser() && lst.hasKey('requestedView')) {
      // requestedView key gets set in router.js if we got redirected to login screen
      const reqView = lst.getValue('requestedView')
      console.log('*this is a mobile browser* - requestedView is ' + reqView)
      if (reqView.indexOf('/findaspace') !== -1 && reqView.indexOf('roomId') !== -1) {
        // it's probably a signage link - e.g. /findaspace?roomId=1730659&slot=now&src=sng
        const roomId = findRoomId(reqView)
        if (typeof roomId !== 'undefined') {
          location.href = 'uofglife://booking?src=sng&roomId=' + roomId
        } else {
          console.error('Given a findaspace link with room but could not find roomId')
        }
      }


    }

    const tokenResponse = await catchRedirect()
    console.log(tokenResponse)
    if (tokenResponse != null && typeof tokenResponse !== 'undefined') {
      if (typeof tokenResponse.accessToken !== 'undefined') {
        this.accessToken = tokenResponse.accessToken
        console.log('OK, we should be ready to login now!')
        this.login()
      }
    }






    // Checks cached login token
    if (lst.hasKey('guid')) {
      this.$refs.spinner.spin()
      var passGuid = lst.getValue('guid')
      var passToken = lst.getValue('token')
      axios.put('/timetable/login', {
        guid: lst.getValue('guid'),
        token: lst.hasKey('token') ? lst.getValue('token') : 'NONE!'
      })
        .then(response => {
          if (response.data.skipLogin) {
            this.setCookiesAndForward(response, passGuid, passToken)
          }
        }).finally(() => {
          if (this.$refs.spinner) {
            this.$refs.spinner.stop()
          }
        })
    }
  },
  methods: {
    isInMobileBrowser () {
      const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
      ]

      return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem)
      })
    },
    async checkLogin () {
      // with Azure it's 2 steps:
      // 1. go to MS and do the login there (may open a window, do MFA etc)
      // 2. use the access token we hopefully got, and login to the backend, getting user app info
      const account = await getAccount()
      if (typeof account === 'undefined') {
        // we may need to actually get the user logged into MS here
        console.log('user needs to login to MS...')
        startRedirect()
      } else {
        this.accessToken = await getToken(account)
        if (typeof this.accessToken !== 'undefined') {
          this.login()
        }

      }
    },
    // Makes a login request
    login () {
      this.disableLogin = true
      this.buttonClicked = true
      this.$refs.spinner.spin()
      axios.post('/timetable/login/azure', {}, {
          withCredentials: true,
          headers: { Authorization: 'Bearer ' + this.accessToken }
      })
        .then(response => {
          if (this.rememberMe) {
            let expires = new Date()

            expires.setTime(expires.getTime() + (response.data.cachedLogin.expires * 1000))
            lst.setValue('guid', response.data.cachedLogin.guid) //, expires.toUTCString()
            lst.setValue('token', response.data.cachedLogin.token) //, expires.toUTCString()
            // if we have a mapped guid let's include that also
            if (typeof response.data.mappedGuid !== 'undefined') {
              lst.setValue('mappedGuid', response.data.mappedGuid) //, expires.toUTCString())
            }
          }
          if (!(process.env.VUE_APP_MODE === 'hybrid')) {
            axios.post('/timetable/notifications', { token: null }) // this is here to limit # calls to server
          }
          lst.setValue('showNotifications', true)
          // and update...
          // lst.setValues(this.cookies)
          this.setCookiesAndForward(response)
        })
        .catch((error) => {
          console.log(error)
          this.disableLogin = false
          this.buttonClicked = false
        })
        .finally(() => {
          if (this.$refs.spinner) {
            this.$refs.spinner.stop()
          }
          let a = this
          window.addEventListener('beforeunload', function () {
            a.buttonClicked = false
          })
          // this.buttonClicked = false
        })
    },
    // sends firebase token to db. checks to see if android or ios device.
    setNotificationToken () {
      if (process.env.VUE_APP_MODE === 'hybrid') {
        if (typeof window.FirebasePlugin !== 'undefined') {
          console.log(typeof window.FirebasePlugin)
          // Check permission.
          window.FirebasePlugin.hasPermission(
            hasPermission => {
              if (hasPermission) {
                // iOS and Android.
                this.storeFirebaseToken()
              } else {
                if (navigator.userAgent.match(/iPhone|iPad/)) {
                // Seek permission on iOS on first time use.
                  window.FirebasePlugin.grantPermission(
                    hasPermission => {
                      if (hasPermission) {
                        this.storeFirebaseToken()
                      } else {
                        this.storeNotAllowedToken()
                      }
                    },
                    err => {
                      this.alert(err)
                    })
                } else {
                // Android.
                  this.storeNotAllowedToken()
                }
              }
            },
            err => {
              this.alert(err)
            })
        } else {
          console.error('in hybrid mode but window.FirebasePlugin is not defined!')
        }
      }
    },
    // Gets this device's token from Firebase and if it is new then store on the client and server.
    storeFirebaseToken () {
      window.FirebasePlugin.getToken(
        fcmToken => {
          if (lst.getValue('notificationToken') != fcmToken) {
            axios.post('/timetable/notifications', { 'token': fcmToken })
              .then(() => {
                // $cookies.set('notificationToken', fcmToken, '364d')
                lst.setValue('notificationToken', fcmToken)
              })
          }
        },
        err => {
          this.alert(err)
        })
    },
    // Stores the token as "notAllowed" on client and server. The server will ignore these and not send a message.
    storeNotAllowedToken () {
      if (lst.getValue('notificationToken') != 'notAllowed') {
        axios.post('/timetable/notifications', { 'token': 'notAllowed' })
          .then(() => {
            lst.setValue('notificationToken', 'notAllowed')
          })
      }
    },

    setAdditionalInfo (response) {
      let expires = new Date()
      // console.log(expires.getTime())
      // console.log(response.data)

      if (typeof response.data.cachedLogin !== 'undefined') {
      //  console.log(response.data.cachedLogin.expires)
      //  console.log(response.data.cachedLogin.expires * 1000)
        expires.setTime(expires.getTime() + (response.data.cachedLogin.expires * 1000))
      } else {
        expires.setTime(expires.getTime() + (60 * 60 * 24 * 365 * 1000))
      }

      // and default booking times for the new screen
      /* if (typeof response.data.bookingTimes !== 'undefined') {
        lst.setValue('bookingStartHour', response.data.bookingTimes.startHour) // , expires.toUTCString())
        lst.setValue('bookingEndHour', response.data.bookingTimes.endHour) // , expires.toUTCString())
      } */
    },
    // Sets cookies and forwards to requested screen.
    setCookiesAndForward (response, newGuid, newToken) {
      var ms = Date.now()

      if (lst.getValue('logoutActivated') === true) {
        lst.setValue('logoutActivated', false)
        this.$router.push('/logout')
      }

      // TEST indexedDb code
      const rd = response.data
      const hasCachedLogin = typeof rd.cachedLogin !== 'undefined'
      // this.errorMsg = 'DEBUG: *** newGuid = ' + newGuid + (hasCachedLogin ? 'there is login data' : 'no cached login :-/')
      let cachedLoginGuid = newGuid
      let cachedLoginToken = newToken
      let nonnullCLG = (typeof cachedLoginGuid !== 'undefined' && cachedLoginGuid != null)
      let nonnullCLT = (typeof cachedLoginToken !== 'undefined' && cachedLoginToken != null)
      if (hasCachedLogin) {
        cachedLoginGuid = rd.cachedLogin.guid
        cachedLoginToken = rd.cachedLogin.token
        nonnullCLG = (typeof cachedLoginGuid !== 'undefined' && cachedLoginGuid !== null)
        nonnullCLT = (typeof cachedLoginToken !== 'undefined' && cachedLoginToken !== null)

        console.log('there is a cached login with cached guid ' + cachedLoginGuid)
      }

      const idata = {
        'authenticated': true, /* only used to tip off the UI there is a logged-in user */
        'showHomepageNotice': true,
        'guid': nonnullCLG ? cachedLoginGuid : lst.getValue('guid'),
        // WCSC-2119 removing token seems to be causing trouble with skipLogin
        //           so we'll keep it in for now
        // WCSC-2118 i don't understand why lst.getValue('guid') has a value in mounted() but is empty here :-/
        'token': nonnullCLT ? cachedLoginToken : lst.getValue('token'),
        'mappedGuid': rd.mappedGuid,
        'hasRoomBookingAccess': rd.hasRoomBookingAccess,
        'hasDeskBookingAccess': rd.hasDeskBookingAccess,
        'name': rd.firstname,
        'showPopupStudySpace': rd.showPopupStudySpace,
        'assessmentDataAvailable': rd.assessmentDataAvailable,
        'showAssessmentAndFeedback': rd.showAssessmentAndFeedback,
        'noTimetable': rd.noTimetable,
        'showLecturer': rd.showLecturer,
        'featureList': rd.featureList,
        'cacheClearNeeded': rd.cacheClearNeeded,
        'unreadNotifications': rd.unreadNotifications,
        'libraryHours': rd.libraryHours,
        /* 'bookingTimes': rd.bookingTimes, */
        'userRoles': rd.userRoles,
        'indexTime': ms,
        'timetableTime': ms,
        'footerMenu': JSON.stringify(rd.footerMenu),
        'showLibraryInformation': rd.showLibraryInformation
      }
      lst.setValues(idata)
      console.log('data saved for guid ' + idata['guid'])
      // END TEST
      this.setAdditionalInfo(response)
      this.checkForMaintScreenAnalytics()
      console.log('pushing requested view')
      this.setNotificationToken()
      this.$router.push(this.getRequestedView())
    },
    // Returns the request view
    getRequestedView () {
      let requestedView = '/'
      if (lst.hasKey('requestedView')) {
        requestedView = lst.getValue('requestedView')
        // delete this.cookies['requestedView']
        lst.deleteValue('requestedView')
      }
      return requestedView
    },
    checkForMaintScreenAnalytics() {
      if (lst.hasKey('maintscreens')) {
        const maintscreens = lst.getValue('maintscreens')
        // send to server for recording/analysis/etc
        console.log('found unsent maint screen records...')
        axios.post('/timetable/public/maintscreen/report', maintscreens)
        .then(response => {
          if (typeof response.data !== 'undefined') {
            console.log(response.data)
          }
        })
        .finally(() => {
          // delete it
          console.log('clearing maint screen records...')
          lst.deleteValue('maintscreens')
        })
      }
    }
  }
}
</script>
<style scoped>
.error-message {
  color: red;
  margin-bottom: 10px;
}

#loginLogo {
  height:200px;
  background-color: var(--uog-dark-blue);
  text-align:center;
}

.loginLogoImg {
  margin-top: 60px;
  display:inline-block;
  width:110px;
  height: 110px;
  padding: 10px 29px;
}

.loginElement {
  background: rgba(118, 118, 128, 0.12);
  border-radius: 10px;
  height:52px;
  font-family:PTSans;
  border:0px rgba(118, 118, 128, 0.12);
  padding-left:12px;
  padding-right:12px;
  margin-top:12px;
  width:100%;

}

.loginButtonDisabled {
  background-color:#C3C5CB;
  width:100%;
  color:#ffffff;
  font-family:PTSans;
  border: 1px solid #C3C5CB;
  border-radius:12px;
  height:52px;
  margin-top:24px;
  margin-bottom:21px;
  font-weight:700;
}

.loginButton {
  background-color: var(--uog-dark-blue);
  width:100%;
  color:#ffffff;
  font-family:PTSans;
  border: 1px solid var(--uog-dark-blue);
  border-radius:12px;
  height:52px;
  margin-top:24px;
  margin-bottom:21px;
  font-weight:700;
}

.loginElement::placeholder {
  color:#4F5961;
}

.loginElement:focus {
 outline: 1px solid #951272 !important;
}

.privacyStatement {
  color: var(--uog-dark-blue);
  font-weight:bold;

}
</style>
